import { safeParseJson } from "common/utils/json";
import { fontFaceManager } from "../../globals/FontFaceManager";

/**
 * Loads the assets for a slideshow, slide by slide.
 * Loads the first and second slides on start,
 * then the caller must call `loadForSlideElement` to load subsequent slides as the slideshow progresses.
 *
 * It loads:
 *   - font faces via window.fontFaceManager
 *   - background images by setting the background-image CSS rule
 */
export class SlideshowAssetLoader {
  /**
   * @param {HTMLElement} slideshowElement
   */
  constructor(slideshowElement) {
    this.slideshowElement = slideshowElement;
  }

  // The first slide is needed immediately; the second one is prefetched shortly
  // after so that the first transition doesn't have to wait for it.
  loadInitial() {
    this.loadForSlideElement(this.slideshowElement.children[0]);

    const secondElement = this.slideshowElement.children[1];
    if (secondElement) {
      setTimeout(() => this.loadForSlideElement(secondElement), 500);
    }
  }

  // Load the assets for the given slide.
  // Called after a transition to preload the upcoming slide.
  loadForSlideElement(slideElement) {
    if (!slideElement) {
      return;
    }

    this.loadFontForSlideElement(slideElement);
    this.loadBackgroundImageForSlideElement(slideElement);
  }

  loadFontForSlideElement(slideElement) {
    const renderedTextElement = slideElement.querySelector(".rendered_text");
    if (!renderedTextElement) {
      console.warn("No rendered text element found in slide", slideElement);
      return;
    }

    // generated in sample_helper.rb
    const fontFaceParamssJSON = renderedTextElement.dataset.fontFaceParams;

    /** @type {fontFaceParams[]} */
    const fontFaceParamss = safeParseJson(fontFaceParamssJSON);
    if (!fontFaceParamss) {
      return;
    }

    fontFaceParamss.forEach((fontFaceParams) => {
      fontFaceManager.add(fontFaceParams);
    });
  }

  loadBackgroundImageForSlideElement(slideElement) {
    const url = slideElement.dataset.backgroundImageUrl;
    if (!url) {
      return;
    }

    const imageElement = slideElement.querySelector(".slide-bg");
    if (!imageElement) {
      console.warn("No image element found in slide", slideElement);
      return;
    }
    imageElement.style.backgroundImage = `url('${url}')`;
  }
}
